import Cookies from 'js-cookie';

const ready = callback => {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
  else callback();
};
const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
const setClass = (selector, name, value) => all(selector).forEach(element => element.classList.toggle(name, value));
const attr = (selector, name, value) => all(selector).forEach(element => element.setAttribute(name, String(value)));
const delegate = (type, selector, callback) => document.addEventListener(type, event => {
  const target = event.target instanceof Element ? event.target.closest(selector) : null;
  if (target) callback(event, target);
});

export function initLandingMenu() {
  const toggle = expanded => {
    document.body.classList.toggle('openflyout', expanded);
    setClass('#mainmenu_layer', 'mainmenu-layer__open', expanded);
    setClass('#lp_mainmenu_toggle', 'mainmenu-trigger__active', expanded);
    setClass('#lp_mainmenu_toggle', 'lbbw-icf--close', expanded);
    attr('#lp_mainmenu_toggle', 'aria-expanded', expanded);
    attr('#mainmenu_layer', 'aria-hidden', !expanded);
    all('#mainmenu_layer a, #mainmenu_layer button').forEach(element => {
      if (expanded) element.removeAttribute('tabindex');
      else element.setAttribute('tabindex', '-1');
    });
    if (expanded) setClass('.flyout', 'flyout__active', false);
  };
  delegate('click', '#lp_mainmenu_toggle', () => toggle(!document.body.classList.contains('openflyout')));
  delegate('click', '.jumplink', () => {
    if (document.body.classList.contains('openflyout')) toggle(false);
  });
}

export function initFaq() {
  ready(() => {
    attr('.faq .faq__question', 'aria-expanded', false);
    attr('.faq .faq__answer', 'aria-hidden', true);
    delegate('click', '.container.content.faq .faq__question', (event, button) => {
      const item = button.closest('.faq__item');
      const opening = button.getAttribute('aria-expanded') === 'false';
      const toggle = (entry, expanded) => {
        all('.faq__question', entry).forEach(question => question.setAttribute('aria-expanded', String(expanded)));
        all('.faq__answer', entry).forEach(answer => answer.setAttribute('aria-hidden', String(!expanded)));
        entry.classList.toggle('opened', expanded);
      };
      all('.faq__item.opened').filter(entry => entry !== item).forEach(entry => toggle(entry, false));
      toggle(item, opening);
    });
  });
}

export function initBuyPartners() {
  delegate('change', '.fondsdetail-buy-places input[type="radio"]', (event, radio) => {
    if (Cookies.get('LBBWAMDisclaimerAccepted')) attr('#buy_to_step2', 'href', radio.value);
    attr('#buy_redirect', 'href', radio.value);
    setClass('#buy_step1_footer', 'fondsdetail-buy-footer__hidden', false);
  });
}

export function initConsultation() {
  const accepted = Cookies.get('LBBWAMDisclaimerAccepted');
  delegate('click', '.consult-open-btn', () => {
    setClass('#fondsdetail_consulting', 'fondsdetail-buy__open', true);
    document.body.classList.add('openlayer');
  });
  delegate('click', '#consult_close', () => {
    setClass('#fondsdetail_consulting', 'fondsdetail-buy__open', false);
    setClass('#consult_step1', 'fondsdetail-buy-step__hidden', false);
    setClass('#consult_step2', 'fondsdetail-buy-step__hidden', true);
    document.body.classList.remove('openlayer');
  });
  delegate('click', '#to_step2', (event, link) => {
    event.preventDefault();
    if (accepted) window.open(link.getAttribute('href'), '_blank');
    else {
      setClass('#consult_step1', 'fondsdetail-buy-step__hidden', true);
      setClass('#consult_step2', 'fondsdetail-buy-step__hidden', false);
    }
  });
  delegate('change', '.consultant-list input[type="radio"]', (event, radio) => {
    if (accepted) attr('#to_step2', 'href', radio.value);
    attr('#consult_redirect', 'href', radio.value);
    setClass('#consult_step1_footer', 'fondsdetail-buy-footer__hidden', false);
  });
  delegate('click', '#consult_redirect', (event, link) => {
    event.preventDefault();
    // Preserve the existing consultation cookie lifetime and redirect behavior.
    Cookies.set('LBBWAMDisclaimerAccepted', 'true', { expires: 3600, path: '/' });
    window.open(link.getAttribute('href'), '_blank');
  });
}

export function initLandingDetails() {
  const update = () => attr('#updown', 'aria-expanded', !!document.querySelector('.hero .headerBox.open'));
  delegate('click', '#updown', () => {
    all('.hero .headerBox').forEach(element => element.classList.toggle('open'));
    update();
  });
  ready(update);
}

export function initVideoLayer() {
  const toggle = expanded => {
    all('#videoLayer').forEach(layer => {
      layer.classList.toggle('videoPlayer__open', expanded);
      layer.style.display = expanded ? 'block' : 'none';
    });
    document.body.classList.toggle('openlayer', expanded);
    if (!expanded) {
      const videos = all('video');
      if (videos.length) videos.forEach(video => { video.pause(); video.currentTime = 0; });
      else all('iframe').forEach(iframe => { iframe.src = iframe.src; });
    }
  };
  delegate('click', '#open_video', () => toggle(true));
  delegate('click', '#videoLayer_close', () => toggle(false));
  delegate('click', '#videoLayer', event => {
    if (!event.target.closest('.video')) toggle(false);
  });
}

let videoPreviewInitialized = false;
export function initVideoPreviews() {
  if (videoPreviewInitialized) return;
  videoPreviewInitialized = true;
  delegate('click', '.podcastblock .video-shariff-play', (event, preview) => {
    event.preventDefault();
    preview.outerHTML = JSON.parse(preview.dataset.video);
  });
}

export function initPodcast() {
  initVideoPreviews();
  const time = seconds => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
  const duration = audio => {
    const podcast = audio.closest('.audio.podcast');
    if (podcast) all('.total-time', podcast).forEach(element => { const text = time(audio.duration); if (element.textContent !== text) element.textContent = text; });
  };
  const progress = audio => {
    const podcast = audio.closest('.audio.podcast');
    if (!podcast) return;
    const percent = audio.currentTime / audio.duration * 100;
    all('.progress-bar', podcast).forEach(element => { element.value = percent; });
    podcast.style.setProperty('--seek-before-color', '#31af82');
    podcast.style.setProperty('--seek-before-width', `${Math.min(Math.ceil(percent * 10) / 10, 98.9)}%`);
    all('.current-time', podcast).forEach(element => { element.textContent = time(audio.currentTime); });
  };
  // Capture media events, which do not bubble, also after asynchronous fund markup replacement.
  document.addEventListener('loadedmetadata', event => {
    if (event.target.matches?.('.audio.podcast audio')) duration(event.target);
  }, true);
  document.addEventListener('timeupdate', event => {
    if (event.target.matches?.('.audio.podcast audio')) progress(event.target);
  }, true);
  const playing = new WeakMap();
  delegate('click', '.audio.podcast button', (event, button) => {
    const podcast = button.closest('.audio.podcast');
    const audio = podcast.querySelector('audio');
    if (!audio) return;
    if (button.classList.contains('toggle-play')) {
      const play = !playing.get(audio);
      if (play) audio.play().catch(() => {});
      else audio.pause();
      playing.set(audio, play);
      button.classList.toggle('pause', play);
      button.classList.toggle('play', !play);
    } else if (button.classList.contains('start-position')) {
      audio.currentTime = 0;
      podcast.style.setProperty('--seek-before-width', '0%');
    } else if (button.classList.contains('end-position')) audio.currentTime = audio.duration;
  });
  delegate('change', '.audio.podcast input', (event, input) => {
    const audio = input.closest('.audio.podcast').querySelector('audio');
    if (!audio) return;
    if (input.matches('.volume-control')) audio.volume = Number(input.value);
    if (input.matches('.progress-bar')) audio.currentTime = input.value * audio.duration / 100;
  });
  const updateDurations = () => all('.audio.podcast audio').filter(audio => audio.readyState > 0).forEach(duration);
  ready(updateDurations);
  new MutationObserver(updateDurations).observe(document.body, { childList: true, subtree: true });
}

export function initPodcastDummy() {
  let playing = false;
  delegate('click', '.podcast.play-pause-button', () => {
    const audio = document.querySelector('audio');
    if (!audio) return;
    if (playing) audio.pause();
    else audio.play().catch(() => {});
    playing = !playing;
  });
}

export function initLetscast(buttonSelector, containerSelector, markup) {
  delegate('click', buttonSelector, event => {
    event.preventDefault();
    all(containerSelector).forEach(container => {
      container.innerHTML = markup.replaceAll('&lt;', '<').replaceAll('&gt;', '>');
    });
  });
  initVideoPreviews();
}

window.LBBWComponents = { initLandingMenu, initFaq, initBuyPartners, initConsultation, initLandingDetails, initVideoLayer, initPodcast, initPodcastDummy, initLetscast };
